import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import './DataTable.css';

const DataTable = (props) => {
    const [selectAll, setSelectAll] = React.useState(false);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [data, setData] = React.useState(props.rows || []);
    const [filters, setFilters] = React.useState(props.filters || {});

    useEffect(() => {
        setData(props.rows || []);
    }, [props.rows]);


    useEffect(() => {
        let filter = { ...filters };
        if (props.columns) {
            props.columns.map((column) => {
                if (!filter[column.field]) {
                    filter[column.field] = '';
                }
            });
        }

        setFilters(filter);
    }, [props.columns]);


    useEffect(() => {
        filterData();
    }, [filters]);

    useEffect(() => {
        // console.log('selectedRows', selectedRows);
    }, [selectedRows]);

    const tableFilterItems = (item, index) => {

        if (item.filter) {
            if (item.filterType === 'text') {
                return <input
                    type="text"
                    className="form-control py-1 px-2"
                    onChange={(e) => {
                        let filterKey = item.field;
                        setFilters({ ...filters, [filterKey]: e.target.value });
                    }}
                    value={filters[item.field] || ''}
                />;

            }
            if (item.filterType === 'select') {
                return <select
                    className="form-control py-1 px-2"
                    onChange={(e) => {
                        let filterKey = item.field;
                        setFilters({ ...filters, [filterKey]: e.target.value });
                    }}
                    value={filters[item.field]}>
                    {item.filterList.map((option, index) => {
                        return <option key={index} value={option.value}>{option.label}</option>;
                    })}
                </select>;
            }
            if (item.filterType === 'action') {
                return item.action;
            }

        }
    };


    const filterData = (data = props.rows) => {
        let filteredData = [];

        if (Object.keys(filters).length > 0) {
            filteredData = data.filter((item) => {
                let isValid = true;

                Object.keys(filters).map((key) => {
                    if (filters[key] && item[key]) {
                        let itemValue = item[key].value;
                        let filterValue = filters[key];

                        // console.log('itemValue', itemValue);
                        // console.log('filterValue', filterValue);

                        if (typeof itemValue === 'string') {
                            if (!itemValue.includes(filterValue)) {
                                isValid = false;
                            }
                        }
                        if (typeof itemValue === 'number') {
                            if (itemValue !== parseInt(filterValue)) {
                                isValid = false;
                            }
                        }
                        if (typeof itemValue === 'boolean') {
                            filterValue = filterValue === 'true' ? true : false;
                            if (itemValue !== filterValue) {
                                isValid = false;
                                // console.log('Boolean', itemValue, filterValue);
                            }
                        }

                    }
                });
                return isValid;
            });
            setData(filteredData);
            props.setFilters && props.setFilters(filters);
            props.setFilterData && props.setFilterData(filteredData);
        }
    };

    const clearFilter = () => {
        let filter = { ...filters };
        if (props.columns) {
            props.columns.map((column) => {
                filter[column.field] = '';
            });
        }

        setFilters(filter);
    };


    return (
        <>
            <div className="table-filters">

            </div>
            <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th className="text-center">
                            <input
                                type="checkbox"
                                className="form-check-input pointer"
                                checked={selectAll}
                                onChange={() => {
                                    setSelectAll(!selectAll);
                                    if (selectAll) {
                                        setSelectedRows([]);
                                    } else {
                                        setSelectedRows(data.map(item => item['id'].value));
                                    }

                                }}
                            />
                        </th>
                        {
                            props.columns && props.columns.map((col, index) => {
                                return <th key={'col-' + index} {...col.attributes}>{col.label}</th>;
                            })
                        }
                    </tr>

                </thead>
                <tbody>
                    <tr className="">
                        <td className="text-center">
                            <i className="fa fa-filter" ></i>
                        </td>
                        {
                            props.columns && props.columns.map((col, index) => {
                                if (index === props.columns.length - 1) {
                                    return <td key={'col-' + index} {...col.attributes}>
                                        <Button variant="link btn-text" onClick={() => clearFilter()}>Clear</Button>
                                    </td>;
                                }
                                if (col.filter) {

                                    return <td key={'col-' + index} {...col.attributes}>
                                        {/* {col.label} */}
                                        {tableFilterItems(col, index)}
                                    </td>;
                                }
                                else {
                                    return <td key={'col-' + index} ></td>;
                                }
                            })
                        }
                    </tr>
                    {
                        data && data.map((row, index) => {
                            // console.log(row);
                            return (
                                <tr key={'row-' + row['id'].value}>
                                    <td className="text-center">
                                        <input type="checkbox"
                                            className="form-check-input pointer"
                                            checked={selectedRows.includes(row['id'].value)}
                                            onChange={() => {
                                                if (selectedRows.includes(row['id'].value)) {
                                                    setSelectedRows(selectedRows.filter(id => id !== row['id'].value));
                                                } else {
                                                    setSelectedRows([...selectedRows, row['id'].value]);
                                                }
                                            }}
                                        />
                                    </td>
                                    {props.columns.map((col, index) => {
                                        return <td key={'col-' + row['id'].value + index} className={col.attributes['className']}>{row[col.field].label}</td>;
                                    })}

                                </tr>
                            );
                        })
                    }
                </tbody>
            </table>
            <div className="table-pagination">

            </div>
        </>
    );
};

export default DataTable;